module.exports = __webpack_public_path__ + "static/media/The_NZ_Shared_Prosperity_Composite_Index.219c4768.pdf";